
/** 生产环境api配置 */
const PROD_CONFIG = {
  API_SERVER: '//api.vhallyun.com/sdk',
  REPORT_SERVER: '//dc.e.vhall.com/login'
}
/** 开发环境api配置 */
const DEVELOP_CONFIG = {
  API_SERVER: '//t-open.e.vhall.com/sdk',
  REPORT_SERVER: '//t-dc.e.vhall.com/login'
}

export const CONFIG =
  process.env.NODE_ENV === 'production' ? PROD_CONFIG : DEVELOP_CONFIG
